const initialState = {
  users: [],
};

export default initialState;
